(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-box-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-box-builder')) {
    customElements.define('pm-box-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.motion?.addEventListener?.('change', this.onMotionChange);
          this.onMotionChange?.();
          return;
        }
        this.initialized = true;
        this.flavors = [...this.querySelectorAll('[data-mix-flavor]')];
        if (!this.flavors.length) return;
        this.items = [];
        this.history = [];
        this.capacity = Number(this.dataset.capacity);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.flights = new Set();
        this.timers = new Map();
        this.actorAnimations = new Set();
        this.onMotionChange = () => { if (this.motion.matches) this.cancelMotion(); };
        this.motion.addEventListener?.('change', this.onMotionChange);
        this.querySelectorAll('[data-character-sprite]').forEach((sprite) => {
          const ready = () => { if (sprite.naturalWidth > 0) sprite.closest('[data-mix-flavor]').classList.add('motion-ready'); };
          if (sprite.complete) ready(); else sprite.addEventListener('load', ready, { once: true });
        });
        this.querySelector('.pm-box__interactive').hidden = false;
        this.render();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button) || button.getAttribute('aria-disabled') === 'true') return;
          if (!['data-pack', 'data-undo', 'data-size', 'data-reset', 'data-plus', 'data-minus', 'data-slot', 'data-balanced', 'data-surprise'].some(name => button.hasAttribute(name))) return;
          this.cancelMotion();
          if (button.hasAttribute('data-pack')) { this.packed = !this.packed; this.render(); return; }
          const before = this.items.length;
          const wasFull = before === this.capacity;
          let added;
          let message = '';
          if (button.hasAttribute('data-undo')) {
            const last = this.history.pop();
            if (!last) return;
            this.items = last.items; this.capacity = last.capacity;
          } else {
            if (button.hasAttribute('data-size') && Number(button.dataset.size) === this.capacity) return;
            if (button.hasAttribute('data-reset') && !before) return;
            this.history.push({ items: [...this.items], capacity: this.capacity });
            if (this.history.length > 30) this.history.shift();
            if (button.hasAttribute('data-plus') && before < this.capacity) { added = Number(button.dataset.plus); this.items.push(added); }
            if (button.hasAttribute('data-minus')) { const index = this.items.lastIndexOf(Number(button.dataset.minus)); if (index >= 0) this.items.splice(index, 1); }
            if (button.hasAttribute('data-slot')) this.items.splice(Number(button.dataset.slot), 1);
            if (button.hasAttribute('data-reset')) this.items = [];
            if (button.hasAttribute('data-size')) { this.capacity = Number(button.dataset.size); if (this.items.length > this.capacity) { this.items = this.items.slice(0, this.capacity); message = this.dataset.trimmed; } }
            if (button.hasAttribute('data-balanced')) this.items = Array.from({ length: this.capacity }, (_, i) => i % this.flavors.length);
            if (button.hasAttribute('data-surprise')) this.items = Array.from({ length: this.capacity }, () => Math.floor(Math.random() * this.flavors.length));
          }
          this.packed = false;
          this.render(message);
          if (button.hasAttribute('data-slot') && button.getAttribute('aria-disabled') === 'true') {
            const next = this.querySelector(`[data-slot="${Math.max(0, this.items.length - 1)}"]`);
            (this.items.length ? next : this.querySelector('[data-plus]')).focus({ preventScroll: true });
          }
          if (added !== undefined) { this.addFeedback(added); this.animateAdd(added, this.items.length - 1); }
          if (!wasFull && this.items.length === this.capacity) this.celebrate();
        });
      }
      schedule(key, callback, delay) { clearTimeout(this.timers.get(key)); this.timers.set(key, setTimeout(() => { this.timers.delete(key); callback(); }, delay)); }
      cancelMotion() {
        this.timers?.forEach((timer, key) => { if (key.startsWith('actor-') || key === 'celebration') { clearTimeout(timer); this.timers.delete(key); } });
        this.actorAnimations?.forEach(animation => animation.cancel());
        this.actorAnimations?.clear();
        this.flights?.forEach(({ ghost, animation }) => { animation.cancel(); ghost.remove(); });
        this.flights?.clear();
        this.classList.remove('is-celebrating');
        this.flavors?.forEach(card => { card.classList.remove('is-performing', 'is-added'); const actor = card.querySelector('[data-character-actor]'); if (actor) actor.dataset.pose = '2'; });
      }
      animateAdd(flavor, slotIndex) {
        const card = this.flavors[flavor];
        const actor = card.querySelector('[data-character-actor]');
        const sprite = card.querySelector('[data-character-sprite]');
        if (this.motion.matches) return;
        const profiles = {
          chippy: {
            release: 180, finish: 660, settle: 1150, duration: 1000, hand: [.83, .28], flight: 520, arc: 75,
            frames: [
              { transform: 'translateY(5px) rotate(0deg) scale(.92)', offset: 0 },
              { transform: 'translate(-4px,3px) rotate(-4deg) scale(.97)', offset: .16 },
              { transform: 'translate(4px,-5px) rotate(3deg) scale(1.04)', offset: .32 },
              { transform: 'translateY(-2px) rotate(0deg) scale(1)', offset: .65 },
              { transform: 'translateY(0) rotate(0deg) scale(1)', offset: 1 }
            ]
          },
          oaty: {
            release: 260, finish: 760, settle: 1250, duration: 1100, hand: [.83, .24], flight: 500, arc: 55,
            frames: [
              { transform: 'translateY(3px) rotate(-2deg) scale(.96)', offset: 0 },
              { transform: 'translate(-2px,1px) rotate(-3deg) scale(.98)', offset: .2 },
              { transform: 'translate(3px,-3px) rotate(2deg) scale(1.02)', offset: .38 },
              { transform: 'translateY(-1px) rotate(0deg) scale(1)', offset: .7 },
              { transform: 'translateY(0) rotate(0deg) scale(1)', offset: 1 }
            ]
          },
          matcha: {
            release: 340, finish: 1000, settle: 1500, duration: 1350, hand: [.18, .23], flight: 660, arc: 95,
            frames: [
              { transform: 'translate(-3px,3px) rotate(-5deg) scale(.96)', offset: 0 },
              { transform: 'translate(-5px,-4px) rotate(-3deg) scale(1)', offset: .22 },
              { transform: 'translate(3px,-11px) rotate(4deg) scale(1.03)', offset: .45 },
              { transform: 'translate(2px,-5px) rotate(2deg) scale(1)', offset: .75 },
              { transform: 'translateY(0) rotate(0deg) scale(1)', offset: 1 }
            ]
          }
        };
        const profile = profiles[actor?.dataset.characterActor];
        if (!profile || !sprite?.complete || !sprite.naturalWidth || typeof actor.animate !== 'function') { this.fly(flavor, slotIndex); return; }
        card.classList.add('is-performing');
        actor.dataset.pose = '0';
        const animation = actor.animate(profile.frames, { duration: profile.duration, easing: 'ease-in-out' });
        this.actorAnimations.add(animation);
        animation.finished.catch(() => {}).finally(() => this.actorAnimations.delete(animation));
        this.schedule('actor-release', () => {
          if (!this.isConnected || this.motion.matches || this.items[slotIndex] !== flavor) return;
          actor.dataset.pose = '1';
          const bounds = actor.getBoundingClientRect();
          const width = bounds.width * .45, height = width * 1.22;
          const left = bounds.left + bounds.width * profile.hand[0] - width / 2, top = bounds.top + bounds.height * profile.hand[1] - height / 2;
          this.fly(flavor, slotIndex, { left, top, width, height, right: left + width, bottom: top + height }, profile);
        }, profile.release);
        this.schedule('actor-finish', () => { actor.dataset.pose = '2'; }, profile.finish);
        this.schedule('actor-settle', () => { card.classList.remove('is-performing'); }, profile.settle);
      }
      addFeedback(flavor) {
        const card = this.flavors[flavor];
        card.classList.remove('is-added');
        void card.offsetWidth;
        card.classList.add('is-added');
        this.schedule(`card-${flavor}`, () => card.classList.remove('is-added'), 950);
      }
      celebrate() {
        if (this.motion.matches) return;
        this.classList.remove('is-celebrating');
        void this.offsetWidth;
        this.classList.add('is-celebrating');
        this.schedule('celebration', () => this.classList.remove('is-celebrating'), 1250);
      }
      fly(flavor, slotIndex, origin, profile) {
        if (this.motion.matches) return;
        const source = this.flavors[flavor].querySelector('.pm-box__thumbnail');
        const target = this.querySelector(`[data-slot="${slotIndex}"]`);
        if (!source || !target || typeof source.animate !== 'function') return;
        const from = origin || source.getBoundingClientRect(), to = target.getBoundingClientRect();
        if (to.bottom < 0 || to.top > window.innerHeight || to.right < 0 || to.left > window.innerWidth || from.bottom < 0 || from.top > window.innerHeight || from.right < 0 || from.left > window.innerWidth) return;
        const ghost = source.cloneNode();
        ghost.className = 'pm-box__flying'; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true');
        Object.assign(ghost.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` });
        this.append(ghost);
        const x = to.left + to.width / 2 - from.left - from.width / 2;
        const y = to.top + to.height / 2 - from.top - from.height / 2;
        const animation = ghost.animate([{ transform: 'translate(0,0) rotate(-9deg) scale(1)', opacity: 1 }, { transform: `translate(${x * .5}px,${y * .5 - (profile?.arc ?? 75)}px) rotate(12deg) scale(.95)`, opacity: 1 }, { transform: `translate(${x}px,${y}px) rotate(-5deg) scale(${to.width / from.width})`, opacity: .3 }], { duration: profile?.flight ?? 520, easing: 'cubic-bezier(.25,.7,.3,1)' });
        const flight = { ghost, animation }; this.flights.add(flight);
        animation.finished.catch(() => {}).finally(() => { ghost.remove(); this.flights.delete(flight); });
      }
      render(message = '') {
        const total = this.items.length, filled = total === this.capacity;
        this.dataset.capacity = this.capacity;
        this.classList.toggle('is-full', filled); this.classList.toggle('is-packed', !!this.packed);
        const counts = this.flavors.map((_, i) => this.items.filter(f => f === i).length);
        this.querySelector('[data-count]').textContent = `${total} / ${this.capacity}`;
        this.querySelector('[data-mini-count]').textContent = `${total} / ${this.capacity}`;
        this.querySelector('[data-state]').textContent = filled ? this.dataset.ready : total ? `${this.capacity - total} ${this.dataset.remaining}` : this.dataset.building;
        const progress = this.querySelector('[role="progressbar"]'); progress.setAttribute('aria-valuemax', this.capacity); progress.setAttribute('aria-valuenow', total); progress.firstElementChild.style.width = `${100 * total / this.capacity}%`;
        this.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.size) === this.capacity)));
        this.querySelectorAll('[data-plus]').forEach(b => b.setAttribute('aria-disabled', String(filled)));
        counts.forEach((count, i) => { this.querySelector(`[data-quantity="${i}"]`).textContent = count; this.querySelector(`[data-minus="${i}"]`).setAttribute('aria-disabled', String(!count)); });
        this.querySelectorAll('[data-packed-count]').forEach(label => { label.textContent = counts[Number(label.dataset.packedCount)] || 0; });
        this.querySelector('[data-undo]').setAttribute('aria-disabled', String(!this.history.length));
        const pack = this.querySelector('[data-pack]'); pack.setAttribute('aria-disabled', String(!filled)); pack.firstChild.textContent = this.packed ? this.dataset.reopen : this.dataset.close;
        this.querySelector('.pm-box__finish-hint').style.visibility = filled ? 'hidden' : 'visible';
        const slots = this.querySelector('.pm-box__slots');
        for (let i = 0; i < this.capacity; i++) {
          let slot = slots.children[i];
          if (!slot) { slot = document.createElement('button'); slot.type = 'button'; slot.className = 'pm-box__slot'; slot.dataset.slot = i; slots.append(slot); }
          const flavor = this.items[i], hasFlavor = flavor !== undefined;
          slot.tabIndex = hasFlavor && !this.packed ? 0 : -1;
          slot.setAttribute('aria-disabled', String(!hasFlavor || !!this.packed));
          if (slot.dataset.flavor === String(flavor)) continue;
          slot.dataset.flavor = String(flavor); slot.toggleAttribute('data-filled', hasFlavor); slot.replaceChildren();
          if (hasFlavor) {
            const image = this.flavors[flavor].querySelector('.pm-box__thumbnail');
            if (image) { const clone = image.cloneNode(); clone.removeAttribute('class'); clone.loading = 'eager'; clone.alt = ''; slot.append(clone); } else { const label = document.createElement('span'); label.textContent = this.flavors[flavor].dataset.name; slot.append(label); }
            slot.setAttribute('aria-label', this.flavors[flavor].dataset.removeLabel);
          } else { const label = document.createElement('span'); label.textContent = String(i + 1).padStart(2, '0'); label.setAttribute('aria-hidden', 'true'); slot.append(label); slot.setAttribute('aria-label', String(i + 1)); }
        }
        while (slots.children.length > this.capacity) slots.lastElementChild.remove();
        this.querySelector('[data-announcement]').textContent = [message, `${total} / ${this.capacity}.`, filled ? this.dataset.complete : '', ...counts.map((count,i) => `${this.flavors[i].dataset.name}: ${count}`)].filter(Boolean).join(' ');
        this.dispatchEvent(new CustomEvent('pm:mix-change', { bubbles: true }));
      }
      disconnectedCallback() { this.cancelMotion(); this.timers?.forEach(timer => clearTimeout(timer)); this.motion?.removeEventListener?.('change', this.onMotionChange); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-cookie-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-cookie-explorer')) {
    customElements.define('pm-cookie-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.depth = 0;
        this.labels = this.dataset.nextLabels.split('|');
        this.stages = this.dataset.stageLabels.split('|');
        this.stage = this.querySelector('.pm-peek__stage');
        this.stage.disabled = false;
        this.querySelector('.pm-peek__navigation').hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          if (button.hasAttribute('data-next')) this.change((this.depth + 1) % 4);
          if (button.hasAttribute('data-back')) this.change(Math.max(0, this.depth - 1));
        });
      }
      async change(depth) {
        this.requestedDepth = depth;
        const images = depth === 3 ? this.querySelectorAll('.pm-peek__nutrition') : this.querySelectorAll('.pm-peek__photo');
        this.setAttribute('aria-busy', 'true');
        await Promise.all([...images].map((image) => { image.loading = 'eager'; return image.decode ? image.decode().catch(() => {}) : Promise.resolve(); }));
        if (this.requestedDepth !== depth || !this.isConnected) return;
        this.removeAttribute('aria-busy');
        this.depth = depth;
        this.dataset.depth = depth;
        this.querySelectorAll('[data-depth-copy]').forEach((copy) => { copy.hidden = Number(copy.dataset.depthCopy) !== depth; });
        this.querySelector('[role="status"]').textContent = `${depth + 1} / 4 — ${this.stages[depth]}`;
        this.querySelector('.pm-peek__next > span').textContent = this.labels[depth];
        this.stage.setAttribute('aria-label', this.labels[depth]);
        this.querySelector('[data-back]').disabled = depth === 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-flavor-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-flavor-selector')) {
    customElements.define('pm-flavor-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.buttons = [...this.querySelectorAll('[data-flavor-index]')];
        this.panels = [...this.querySelectorAll('[data-flavor-panel]')];
        if (!this.buttons.length) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        this.select(0, false);
        this.classList.add('is-ready');
        this.querySelector('.pm-flavor__choices').hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-flavor-index]');
          if (button && this.contains(button)) this.select(Number(button.dataset.flavorIndex));
        });
        this.addEventListener('keydown', (event) => {
          const index = this.buttons.indexOf(event.target);
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.buttons[next].focus({ preventScroll: true });
          this.select(next);
        });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, false);
        });
      }
      async select(index, animate = true) {
        if (!this.panels[index]) return;
        this.requestedIndex = index;
        if (this.activeIndex === index) {
          this.removeAttribute('aria-busy');
          return;
        }
        if (animate) {
          this.setAttribute('aria-busy', 'true');
          await Promise.all([...this.panels[index].querySelectorAll('img')].map((image) => {
            image.loading = 'eager';
            return image.decode ? image.decode().catch(() => {}) : Promise.resolve();
          }));
          if (this.requestedIndex !== index || !this.isConnected) return;
        }
        this.removeAttribute('aria-busy');
        this.activeIndex = index;
        this.animations.forEach((animation) => animation.cancel());
        this.animations = [];
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        const panel = this.panels[index];
        this.style.setProperty('--flavor-color', panel.dataset.color);
        if (animate) this.querySelector('[role="status"]').textContent = panel.querySelector('.pm-flavor__title').textContent;
        if (animate && !this.motion.matches && typeof panel.animate === 'function') {
          for (const element of panel.querySelectorAll('.pm-flavor__art, .pm-flavor__details')) {
            this.animations.push(element.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' }));
          }
        }
      }
      disconnectedCallback() {
        this.animations?.forEach((animation) => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
